import axios from 'axios'
import { getCookie } from "../assets/js/public"

axios.interceptors.request.use(

config => {
  console.log(config)

  let token = localStorage.getItem("doc_token");
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.token = token;
        }
        const uid = localStorage.getItem("doc_userid");
    if (uid != null) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['userid'] = uid
      // console.log(store.getters.token)
    }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    response => {
        let token = response.headers["token"]
        if(token != null && token !== ''){
            localStorage.setItem("doc_token",token);
        }
        return response;
    },
    err => {
        return Promise.reject(err);
    }
);
// let base = 'http://test3.bjskpj.cn/GrandCanalPlatform'
// let base = 'http://192.168.31.24:8080/GrandCanalPlatform';

//请求地址
let code_url = "/getCaptchaCode"
let login_url = "/login?code=" //登录
let register_url = "login" //注册
let changepPass_url = "login" //修改密码
let index_search_url = "" //首页搜索
let detail_url = "" //详情页
let collect_url = "" //收藏
let hot_url = "" //收藏
let txt_url = "" //在线阅读

let canal_url = "/api/v1/canal?categoryId=1" //大运河搜索接口
let beijing_url = "/api/v1/canal?categoryId=2" //北京研究搜索接口
let tianjin_url = "/api/v1/canal?categoryId=3" //京津翼搜索接口
let award_url = "/api/v1/award" //评奖 搜索接口
let topic_url = "/api/v1/topic" //课题成果搜索接口
let fund_url = "/api/v1/fund" //基金成果搜索接口
let yearbook_url = "/api/v1/yearbook?categoryId=2" //年鉴库搜索接口
let journal_url = "/api/v1/yearbook?categoryId=1" //期刊库搜索接口

let canal_detail_url = "/api/v1/canal" //大运河、北京、京津翼详情接口
let award_detail_url = "/api/v1/award" //评奖详情接口
let topic_detail_url = "/api/v1/topic" //课题成果详情接口
let fund_detail_url = "/api/v1/fund" //基金成果详情接口
let jour_year_detail_url = "/api/v1/yearbook" //期刊年鉴库详情接口

export const axios_code = params => { return axios.get(code_url + params).then(res => res.data) }
export const axios_login = (code, params) => { return axios.post(login_url + code, params).then(res => res.data) }
export const axios_register = params => { return axios.post(register_url, params).then(res => res.data) }
export const axios_changePass = params => { return axios.post(changepPass_url, params).then(res => res.data) }
export const axios_idx_search = params => { return axios.post(index_search_url, params).then(res => res.data) }
export const axios_details = params => { return axios.post(detail_url + params).then(res => res.data) }
export const axios_collect = params => { return axios.post(collect_url, params).then(res => res.data) }
export const axios_hot = params => { return axios.get(hot_url).then(res => res.data) }

export const axios_txt = params => { return axios.post(txt_url + params).then(res => res.data) }

//////////////////////////////////////////大运河表格
export const axios_canal = params => { return axios.get(canal_url + params).then(res => res.data) }
export const axios_beijing = params => { return axios.get(beijing_url + params).then(res => res.data) }
export const axios_tianjin = params => { return axios.get(tianjin_url + params).then(res => res.data) }
export const axios_canal_detail = params => { return axios.get(canal_detail_url + params).then(res => res.data) }
    //////////////////////////////////////////评奖表格
export const axios_award = params => { return axios.get(award_url + params).then(res => res.data) }
export const axios_award_detail = params => { return axios.get(award_detail_url + params).then(res => res.data) }
    //////////////////////////////////////////课题成果表格
export const axios_topic = params => { return axios.get(topic_url + params).then(res => res.data) }
export const axios_topic_detail = params => { return axios.get(topic_detail_url + params).then(res => res.data) }
    //////////////////////////////////////////基金成功成果表格
export const axios_fund = params => { return axios.get(fund_url + params).then(res => res.data) }
export const axios_fund_detail = params => { return axios.get(fund_detail_url + params).then(res => res.data) }
    //////////////////////////////////////////年鉴库表格
export const axios_yearbook = params => { return axios.get(yearbook_url + params).then(res => res.data) }
    //////////////////////////////////////////期刊库表格
export const axios_journal = params => { return axios.get(journal_url + params).then(res => res.data) }
export const axios_yearbook_detail = params => { return axios.get(jour_year_detail_url + params).then(res => res.data) }



// WEBPACK FOOTER //
// ./src/api/api.js